export default __webpack_public_path__ + "static/unleash-joy-compact-9bd03d9516600b0dbc4d4f3083bc1199.svg";